import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider as LocalizationProviderMUI } from "@mui/x-date-pickers/LocalizationProvider";

// Required for RYDE-2388
import "dayjs/locale/en";
import "dayjs/locale/he";

import { FC, PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import { I18N_PUBLIC_NAMESPACE } from "@ryde/shared";

export const LocalizationProvider: FC<PropsWithChildren> = ({ children }) => {
  const { i18n } = useTranslation(I18N_PUBLIC_NAMESPACE, {
    useSuspense: false,
  });

  return (
    <LocalizationProviderMUI
      dateAdapter={AdapterDayjs}
      adapterLocale={i18n.language}
    >
      {children}
    </LocalizationProviderMUI>
  );
};
